import { render, staticRenderFns } from "./InstitutionElement.vue?vue&type=template&id=582aabde&scoped=true&"
import script from "./InstitutionElement.vue?vue&type=script&lang=js&"
export * from "./InstitutionElement.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionElement.vue?vue&type=style&index=0&id=582aabde&scoped=true&lang=scss&"
import style1 from "./InstitutionElement.vue?vue&type=style&index=1&id=582aabde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582aabde",
  null
  
)

export default component.exports